import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import CoinUpgradeManager from "./CoinUpgradeManager";

export default function CoinUpgradePage() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <CoinUpgradeManager />
    </DashboardLayout>
  );
}
